module.exports = __webpack_public_path__ + "static/DSCF8448-7cb71916eadc438f55f3df59fe10f34d.jpg";